import ExternalLinkIcon from '@/components/ExternalLinkIcon'
import { routeFor } from '@/utils/router'
import { translate } from '@/utils/translations'

const TRANSLATION_KEY = 'return_policy.modal.bulk_rules'

const BulkStoreContent = () => (
  <>
    <p>{translate(`${TRANSLATION_KEY}.subtitle`)}</p>
    <ul>
      <li><p>{translate(`${TRANSLATION_KEY}.return_date_policy`)}</p></li>
      <li><p>{translate(`${TRANSLATION_KEY}.unredeemed_codes`)}</p></li>
      <li>
        <p>
          {translate(`${TRANSLATION_KEY}.publisher_exceptions`)}
          <a
            href={routeFor('bulkRefundPolicy')}
            rel='noopener noreferrer'
            target='_blank'
          >
            {' '}
            {translate(`${TRANSLATION_KEY}.return_policy_exceptions_link_text`)}
            <ExternalLinkIcon theme='light' />
          </a>
        </p>
      </li>
      <li><p>{translate(`${TRANSLATION_KEY}.only_vst_codes`)}</p></li>
    </ul>
  </>
)

export default BulkStoreContent
